import React, { Fragment } from "react";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import isEmpty from "assets/scripts/utils/isEmpty";
import validEmail from "assets/scripts/utils/validEmail";
import { ERRORS } from "assets/scripts/constants/FormMessages";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import { showRelationship } from "assets/scripts/components/containers/public/Registration/registrationUtils";
import { defineMessages } from "react-intl";
// tslint:disable-next-line:max-line-length
import DecedentRelationshipFormGroup from "assets/scripts/components/common/form/DecedentRelationshipFormGroup/DecedentRelationshipFormGroup";
const messages = defineMessages({
    emailLabel: {
        id: "forms.accountValidation.email.label",
        defaultMessage: "Email address"
    },
    emailHelp: {
        id: "forms.accountValidation.email.help",
        defaultMessage: "Must be a valid email"
    }
});
export function getErrors(value, deceased) {
    return {
        email: isEmpty(value.email) || !validEmail(value.email) ? ERRORS.EMAIL : getMaxLengthError(value.email, 256),
        relationship: showRelationship(deceased) && value.relationship === "" ? ERRORS.SELECT : null
    };
}
export default function EmailAndRelationshipInputs(props) {
    const { deceased, value, errors, backendErrors } = props;
    const handleUpdate = (update) => props.onChange({
        ...value,
        ...update
    });
    return (<Fragment>
			<TextFormGroup name="email" label={messages.emailLabel} help={messages.emailHelp} value={value.email} onChange={email => handleUpdate({ email })} error={errors.email} backendError={backendErrors.emailAddress} required inputProps={{
        autoComplete: "email"
    }}/>

			{showRelationship(deceased) && (<DecedentRelationshipFormGroup name="relationship" value={value.relationship} onChange={relationship => handleUpdate({ relationship })} error={errors.relationship} backendError={backendErrors.decedentRelationship} required/>)}
		</Fragment>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/EmailAndRelationshipInputs/EmailAndRelationshipInputs.tsx